import Icon from "@imminently/decisively-ui/Icon";
import Button from "@imminently/decisively-ui/Button";

export type ControlsProps = {
  className?: string;
  expanded: boolean;
  toggleExpanded: () => unknown;
};

export const Controls: React.FC<ControlsProps> = (p) => {
  const { expanded, toggleExpanded, className } = p;

  return (
    <div className={`flex h-16 items-center gap-1 self-start ${className ?? ""}`.trim()}>
      <Button icon
        className={expanded ? "border border-[#0A0A0A] bg-[#F9F9F9]" : "border border-[#E0DBDB]"}
        label={expanded ? "Collapse" : "Expand"}
        onClick={toggleExpanded}
      >
        {expanded ? <Icon name="collapse" /> : <Icon name="expand" />}
      </Button>
    </div>
  );
};
